module.exports = __webpack_public_path__ + "static/media/hire-form-completed.0ea49b96.svg";